
export const isEmojiWithoutTextCheck = (message: string) => {
  return /^[\p{Extended_Pictographic}]+[^\d\w\s\rа-я?!@#$%^&*()_+"№;:-=\\\/'><,\.]*$/sugi.test(message)
}
